import { render, staticRenderFns } from "./DocumentForm.vue?vue&type=template&id=6b18d70d&scoped=true"
import script from "./DocumentForm.vue?vue&type=script&lang=js"
export * from "./DocumentForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentForm.vue?vue&type=style&index=0&id=6b18d70d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b18d70d",
  null
  
)

export default component.exports